<div class="main-nav" [class.minimized]="isMinimized">
  <nav class="mi4-navbar-inverse navbar navbar-expand-md flex-md-column navbar-dark align-items-start mi4-nav" [class.navbar-minimized]="isMinimized">
    <!-- Desktop view logo header display -->
    <div class="logo-container text-center bg-white py-0 py-md-2 collapse-control">
      <a class="logo-header" [class.hide-logo]="isMinimized" [routerLink]="['home']" title="Productioneer Portal" data-toggle="collapse" data-target=".navbar-collapse.show"><img id="black-logo-full" src="/assets/Productioneer-logo-white.png" /></a>
      <a class="logo-header" [class.hide-logo]="!isMinimized" [routerLink]="['home']" title="Productioneer Portal"><img id="black-logo-mini" src="/assets/MiniProductioneerLogoBlack_Transparent.png" /></a>
    </div>
    <!-- Mobile view logo header display -->
    <div class="logo-container text-center hide-desktop" style="padding-top: 3px; padding-bottom: 3px; padding-left: 5px; display: flex; align-items: center;">
      <a class="logo-header" [class.hide-logo]="isMinimized" [routerLink]="['home']" title="Productioneer Portal" data-toggle="collapse" data-target=".navbar-collapse.show">
        <img id="black-logo-full" src="/assets/MiniProductioneerLogoBlack_Transparent.png" style="border: 2px solid white; border-radius: 50%; background-color: #03091c !important;" />
      </a>
    </div>
    <div class="navbar-header flex-row">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbarXs">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div class="navbar-collapse collapse mi4-nav-menu flex-column px-2" id="collapsingNavbarXs">
      <ul *ngFor="let app of availableAppLinks; index as i" class="navbar-nav flex-column mi4-navbar-nav py-1" [class.border-top-0]="i == 0" [class.app-hide-element]="!app.enabled">
        <li class="nav-item app-display-name pt-2 mt-1" [class.hide-minimized]="isMinimized">
          {{app.displayName}}
        </li>
        <ng-container *ngFor="let route of app.routes">
          <li *ngIf="route.enabled" class="nav-item" [routerLinkActive]="['link-active']" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a class="nav-link" routerLink="{{app.baseUrl}}/{{route.subUrl}}" title="{{route.displayName}}">
              <i class="{{route.icon}}"></i>
              <span class="pl-2" [class.hide-minimized]="isMinimized">{{route.displayName}}</span>
            </a>
          </li>
        </ng-container>
      </ul>
      <ul class="navbar-nav flex-column mi4-navbar-nav py-1">
        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
          <a class="nav-link rr-main-nav-link" title="Change company" (click)="openUserPage()">
            <i class="fas fa-user"></i>
            <span class="pl-2" [class.hide-minimized]="isMinimized">{{userProfile.name | lowercase}}</span>
          </a>
        </li>
        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
          <a class="nav-link rr-main-nav-link" [routerLink]="['/company-select']" title="Change company">
            <i class="far fa-building"></i>
            <span class="text-warning pl-2" [class.hide-minimized]="isMinimized">{{userProfile.currentCompany | titlecase}}</span>
          </a>
        </li>
        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
          <a class="nav-link" href="mailto:support@mi4.com?Subject=Portal%20Issue" title="Contact support">
            <i class="fas fa-headset"></i>
            <span class="pl-2" [class.hide-minimized]="isMinimized">Support</span>
          </a>
        </li>
        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
          <a class="nav-link" [routerLink]="['/logout']" title="Logout">
            <i class="fas fa-sign-out-alt fa-rotate-180 pl-2"></i>
            <span class="pl-2" [class.hide-minimized]="isMinimized">Logout</span>
          </a>
        </li>
        <li class="nav-item">
          <span class="text-muted" style="font-size: 0.8em;" *ngIf="!isMinimized">Version: </span>
          <span class="text-muted" style="font-size: 0.8em;">{{portalVersion}}</span>
        </li>
      </ul>
      <div class="flex-fill"></div>
      <ul class="navbar-nav flex-column mi4-navbar-nav collapse-control py-2">
        <li class="nav-item">
          <a *ngIf="!isMinimized" class="nav-link collapse-control text-center" style="color: white !important;" (click)="toggleIsMinimized()" title="Collapse menu">
            <i class="fas fa-arrow-circle-left"></i>
            <span class="pl-2">Collapse</span>
          </a>
          <a *ngIf="isMinimized" class="nav-link collapse-control text-center" style="color: white !important;" (click)="toggleIsMinimized()" title="Expand menu">
            <i class="fas fa-arrow-circle-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>
